import { BORDER_RADIUS, CARD_TITLE } from "../../utils/constants";

function CardLayout({
  title,
  children,
  className,
  besideTitleComponent,
  besideComponentStyle,
}: {
  title: string;
    children: React.ReactNode;
    className?: string;
    besideTitleComponent?: React.ReactNode;
    besideComponentStyle?: string;
}) {
  return (
    <div
      className={`bg-white !overflow-x-auto flex flex-col w-full h-[350px] min-h-fit min-w-[300px] ${BORDER_RADIUS} gap-2 p-6 items-center justify-between border border-primary-border text-primary-blackMain ${className}`}
    >
      <div className="w-full flex flex-col md:flex-row gap-4  overflow-visible scrollbar-hide">
        <h3 className={`${CARD_TITLE}`}>{title}</h3>
        <div className={`${besideComponentStyle}`}>{besideTitleComponent}</div>
      </div>
      {children}
    </div>
  );
}

export default CardLayout;
